import { t } from '@lingui/macro';
import { getStaffInboxAttitudes } from 'api/api';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useApi } from '../../../hook/utils';
import { chartsDateRangeSelector } from '../utils';
import InsightConversationList from './InsightConversationList';
import InsightStatisticCard from './InsightStatisticCard';

const MOCK_INBOX_ATTITUDES = {
  data: [
    {
      inbox: { id: 426, name: 'Truyện Thật Vui' },
      staff: { id: 27, name: 'Nobi' },
      failure_criteria: ['Sự thấu cảm (Soft Skills)'],
    },
    {
      inbox: { id: 1370, name: 'tainam' },
      staff: { id: 27, name: 'Nobi' },
      failure_criteria: ['Sự thấu cảm (Soft Skills)', 'Sự chủ động và Xử lý vấn đề'],
    },
    {
      inbox: { id: 1623, name: 'doopage.test.1' },
      staff: { id: 27, name: 'Nobi' },
      failure_criteria: ['Lời chào và Xưng hô'],
    },
  ],
};

const USE_MOCK_DATA = process.env.NODE_ENV === 'development';

const PAGE_SIZE = 11;

const toItem = (item) => ({
  ...item,
  secondary: (item.failure_criteria || []).join(', '),
});

const StaffInboxAttitudes = (props) => {
  const {
    getApi = getStaffInboxAttitudes,
    title = t`Hội thoại có chất lượng tư vấn thấp`,
    canDelete,
    code,
  } = props;
  const { since, until } = useSelector(chartsDateRangeSelector());
  const { loading, doFetch } = useApi();
  const [error, setError] = useState({});
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const fetchPage = async (nextPage) => {
    const { error, data, ...rest } = await doFetch(
      getApi({ since, until, page: nextPage, page_size: PAGE_SIZE }),
    );
    if (error) {
      setError({ error, ...rest });
      return { list: [], more: false };
    }
    const body = data || {};
    const list = (body.data || []).map(toItem);
    const more = body.paging ? body.paging.next != null : list.length >= PAGE_SIZE;
    return { list, more };
  };

  useEffect(() => {
    if (USE_MOCK_DATA) return;
    (async () => {
      if (!since || !until) return;
      setError({});
      setItems([]);
      setPage(1);
      setHasMore(false);
      const { list, more } = await fetchPage(1);
      setItems(list);
      setHasMore(more);
    })();
  }, [since, until]);

  const handleLoadMore = async () => {
    if (loadingMore || !hasMore) return;
    setLoadingMore(true);
    const nextPage = page + 1;
    const { list, more } = await fetchPage(nextPage);
    setItems((prev) => [...prev, ...list]);
    setPage(nextPage);
    setHasMore(more);
    setLoadingMore(false);
  };

  const items_ = USE_MOCK_DATA ? MOCK_INBOX_ATTITUDES.data.map(toItem) : items;

  return (
    <InsightStatisticCard
      title={title}
      canDelete={canDelete}
      code={code}
      loading={!USE_MOCK_DATA && loading && isEmpty(items)}
      error={!USE_MOCK_DATA ? error : {}}
      showEmpty={isEmpty(items_)}
      onLoadMore={!USE_MOCK_DATA && hasMore ? handleLoadMore : undefined}
      loadingMore={loadingMore}>
      <InsightConversationList items={items_} />
    </InsightStatisticCard>
  );
};

StaffInboxAttitudes.propTypes = {
  getApi: PropTypes.func,
  title: PropTypes.string,
  canDelete: PropTypes.bool,
  code: PropTypes.string,
};

export default memo(StaffInboxAttitudes);
